import { createAction } from "@reduxjs/toolkit";

export const initialize = createAction("open-house/initialize");
